import { TFunction } from 'i18next';
import { z } from 'zod';
import { makeZodI18nMap } from 'zod-i18n-map';

export function configureZod(t: TFunction) {
  const map = makeZodI18nMap({ t, ns: 'formValidation' });
  z.setErrorMap(map);
}
